import { CraftnoteEvent } from "../generated/events/CraftnoteEvent.generated";
import { analytics } from "Configs/firebase";
import { logEvent } from "firebase/analytics";

export function dispatchEvent(event: CraftnoteEvent<unknown>): void {
	event.providers.forEach((providerData) => {
		if (providerData.name === "firebase") {
			dispatchFirebaseEvent(
				providerData.eventName,
				event.getParameters() as { [key: string]: string | number | boolean }
			);
		}
	});
}

function dispatchFirebaseEvent(
	eventName: string,
	parameters: { [key: string]: string | number | boolean }
): void {
	if (!analytics) return;
	logEvent(analytics, eventName, parameters);
}
